import { useTranslation } from '../../lib/i18n'

export default function PostReplyNotification({ notification }) {
  const { t } = useTranslation()
  return (
    <>
      <p className="w-full max-w-200 md:max-w-300 truncate overflow-hidden">
        <span className="text-off-black line-clamp-1 font-bold">
          {notification.notifiable?.user?.name}
        </span>{' '}
        {t('notifications.postReply')}
      </p>
      <p className="text-disabled line-clamp-2 break-word">
        {notification.notifiable?.snippet}
      </p>
    </>
  )
}
